<template>
  <div id="content" class="main-content">
    <div class="layout-px-spacing">
      <div class="chat-section layout-top-spacing">
        <div class="row">
          <div class="col-xl-12 col-lg-12 col-md-12">
            <ul
              class="nav nav-pills mb-3 mt-3 justify-content-end"
              id="justify-right-pills-tab"
              role="tablist"
            >
              <li class="nav-item">
                <a
                  class="nav-link "
                  :class="{active: !active}"
                  id="justify-right-pills-home-tab"
                  data-toggle="pill"
                  href="#justify-right-pills-home"
                  role="tab"
                  aria-controls="justify-right-pills-home"
                  aria-selected="true"
                  @click="active = false"
                >Pending</a>
              </li>
              <li class="nav-item">
                <a
                  class="nav-link"
                  :class="{active: active}"
                  id="justify-right-pills-profile-tab"
                  data-toggle="pill"
                  href="#justify-right-pills-profile"
                  role="tab"
                  aria-controls="justify-right-pills-profile"
                  aria-selected="false"
                  @click="active = true"
                >Accepted</a>
              </li>
            </ul>

            <div class="tab-content" id="justify-right-pills-tabContent" v-if="active">
              <div
                class="tab-pane fade show active"
                id="justify-right-pills-home"
                role="tabpanel"
                aria-labelledby="justify-right-pills-home-tab"
              >
                <div class="table-responsive">
                  <table class="table mb-4">
                    <thead>
                      <tr>
                        <th class="text-center">#</th>
                        <th>Name</th>
                        <th>Email</th>
                        <!-- <th>Date Created</th> -->
                        <th>Action</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr v-for="(manager, i) in activePropertyManagers" :key="i">
                        <td class="text-center">{{i+1}}</td>
                        <td class="text-primary">{{manager.fullName}}</td>
                        <td>{{manager.email}}</td>
                        <!-- <td>{{manager.createdAt}}</td> -->
                        <td>
                          <router-link :to="{name: 'view-user-profile', params: {userId: manager._id, type: userType.SUB_ADMIN}}">View Profile</router-link>
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div>
            </div>

            <div class="tab-content" id="justify-right-pills-tabContent" v-if="!active">
              <div
                class="tab-pane fade show active"
                id="justify-right-pills-home"
                role="tabpanel"
                aria-labelledby="justify-right-pills-home-tab"
              >
                <div class="table-responsive">
                  <table class="table mb-4">
                    <thead>
                      <tr>
                        <th class="text-center">#</th>
                        <th>Name</th>
                        <th>Email</th>
                        <!-- <th>Date Created</th> -->
                        <th>Action</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr v-for="(manager, i) in pendingPropertyManagers" :key="i">
                        <td class="text-center">{{i+1}}</td>
                        <td class="text-primary">{{manager.fullName}}</td>
                        <td>{{manager.email}}</td>
                        <!-- <td>{{managers.createdAt}}</td> -->
                        <td>
                          <router-link :to="{name: 'view-user-profile', params: {userId: manager._id, type: userType.SUB_ADMIN}}">View Profile</router-link>
                        </td>
                      </tr>
                    </tbody>
                  </table>
                  <div class="no-estate">
                    <h5 v-if="!pendingPropertyManagers.length" >No Manager Record</h5>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <Footer />
    
  </div>
</template>

<script>
import {USER_TYPE} from '../../helpers/userType';
import Footer from './Footer';

export default {
  components: {
    Footer,
  },
  data(){
    return {
      active: true,
      userType: USER_TYPE
    }
  },
  mounted(){
    this.$store.dispatch('GET_PROPERTY_MANAGERS');
  },
  computed: {
    pendingPropertyManagers(){
      return this.$store.getters.getPendingPropertyManager;
    },
    activePropertyManagers() {
      return this.$store.getters.getActivePropertyManager;
    }
  }
};
</script>

<style scoped>
.no-estate {
  display: flex;
  justify-content: center;
}
</style>